import React from "react";

const logoGlow = {
  // Very light white edge only — no soft glow
  filter:
    "drop-shadow(0 0 0.5px rgba(255,255,255,0.9)) drop-shadow(0 0 0.8px rgba(255,255,255,0.55))",
};

export const LogoMark = ({ size = 44, className = "" }) => (
  <img
    src="/prospera-logo-transparent.png?v=3"
    width={size}
    height={size}
    alt="Prospera Staffing logo"
    className={`shrink-0 ${className}`}
    style={{
      objectFit: "contain",
      ...logoGlow,
    }}
  />
);

export const BrandText = ({ dark = false, large = false }) => (
  <span className="font-accent leading-none tracking-wide flex flex-col justify-center gap-[3px]">
    <span className={large ? "text-xl sm:text-2xl" : "text-lg sm:text-xl"}>
      <span className="text-[#C62828]" style={{ fontWeight: 700 }}>
        PROSPERA
      </span>{" "}
      <span
        className={dark ? "text-[#F7F7F5]" : "text-[#1F1F1F]"}
        style={{ fontWeight: 500 }}
      >
        STAFFING
      </span>
    </span>
    <span
      className={`uppercase ${large ? "text-[10px] sm:text-[11px]" : "text-[10px] sm:text-[11px]"} tracking-[0.16em] ${
        dark ? "text-[#F7F7F5]/85" : "text-[#1F1F1F]/80"
      }`}
      style={{ fontWeight: 600 }}
    >
      Solutions - FZCO
    </span>
  </span>
);

export const Logo = ({ dark = false, onClick, size = 44 }) => (
  <a
    href="#home"
    onClick={onClick}
    data-testid="logo-link"
    className="flex items-center gap-2.5 group select-none"
    aria-label="Prospera Staffing home"
  >
    <LogoMark size={size} className="transition-transform duration-500 group-hover:rotate-[-6deg]" />
    <BrandText dark={dark} />
  </a>
);

export default Logo;
